import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "account-info__items" }
const _hoisted_2 = { class: "account-info-is-over-six-months" }
const _hoisted_3 = { class: "account-info-is-over-six-months__title" }
const _hoisted_4 = { class: "account-info-is-over-six-months__desc" }
const _hoisted_5 = {
  key: 0,
  class: "account-info-is-over-six-months__divider"
}
const _hoisted_6 = { style: {"display":"flex","width":"100%"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"5px 16px 0 0"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*"),
  /*#__PURE__*/_createTextVNode(" 请选择开户银行 ")
], -1)

import { computed, watchEffect } from 'vue';
import {
  BaseFormItem,
  BaseRadio,
  BaseRadioGroup,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import { FY_CHANNEL, IS_OVER_SIX_MONTHS_OPTIONS } from '../../constants';
import infoStore from '../../store/info';
import appStore from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-info-fy',
  setup(__props) {

const { formData } = storeToRefs(infoStore());
const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

/** 供应商不涉及开通方式相关逻辑 */
const isSupplier = computed(() => userInfo.value.functionCode === 3);

/** 供应商不展示开通方式 */
const showOpenWay = computed(() => !isSupplier.value);

/**
 * 展示开户银行：
 * - 供应商：始终展示（与改前一致）
 * - 非供应商：仅开通富友支付时不展示
 */
const showFyChannel = computed(
  () => isSupplier.value || formData.value.isOverSixMonths !== 0
);

const tipsDay = computed(() => {
  return formData.value.fyChannel === '01' ? '1' : '1-2';
});

watchEffect(() => {
  // 非供应商 + 仅开通富友支付：固定中信百信银行
  if (!isSupplier.value && formData.value.isOverSixMonths === 0) {
    formData.value.fyChannel = '01';
  }
  if (formData.value.fyChannel !== '01') {
    !formData.value.fyBeneficiaryInfoList.length &&
      (formData.value.fyBeneficiaryInfoList = [
        {
          name: null,
          certTp: null,
          certNo: null,
          validDateStart: null,
          validDateEnd: null,
          mobile: null,
          address: null,
          portraitFilePath: null,
          badgeFilePath: null,
          beneficiaryType: null
        }
      ]);
    !formData.value.fyShareholderInfoList.length &&
      (formData.value.fyShareholderInfoList = [
        {
          name: null,
          certTp: null,
          certNo: null,
          validDateStart: null,
          validDateEnd: null,
          mobile: null,
          portraitFilePath: null,
          badgeFilePath: null
        }
      ]);
  } else {
    formData.value.fyBeneficiaryInfoList = [];
    formData.value.fyShareholderInfoList = [];
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showOpenWay.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_unref(BaseTextTitle), { class: "account-info__items__title" }, {
            default: _withCtx(() => [
              _createTextVNode("开通方式")
            ]),
            _: 1
          }),
          _createVNode(_unref(BaseTextContent), {
            class: _normalizeClass(["account-info-is-over-six-months-wrap", { 'is-hide-fy-channel': !showFyChannel.value }])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(IS_OVER_SIX_MONTHS_OPTIONS), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.value,
                    class: _normalizeClass(["account-info-is-over-six-months__card", { 'is-active': _unref(formData).isOverSixMonths === item.value }])
                  }, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(item.desc), 1)
                  ], 2))
                }), 128))
              ]),
              (showFyChannel.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"])
        ], 64))
      : _createCommentVNode("", true),
    (showFyChannel.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_unref(BaseTextTitle), {
            class: _normalizeClass(["account-info__items__title", { 'account-info__items__title--follow': showOpenWay.value }])
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 富友支付开户银行 ")
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_unref(BaseTextContent), { style: {"display":"flex","flex-direction":"column","padding-top":"0"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_unref(BaseFormItem), {
                  prop: "fyChannel",
                  rules: [
              {
                required: true,
                trigger: 'change',
                message: '请选择'
              }
            ],
                  style: {"margin-bottom":"0"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseRadioGroup), {
                      modelValue: _unref(formData).fyChannel,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).fyChannel) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FY_CHANNEL), (item) => {
                          return (_openBlock(), _createBlock(_unref(BaseRadio), {
                            key: item.value,
                            value: item.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, "预计开户时间：" + _toDisplayString(tipsDay.value) + "个工作日，实际以银行审核结果为准", 1)
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})